import React, { useEffect, useState } from "react";
import { Button, notification, Result, message, Form, Input } from "antd";
import { useHistory } from "react-router-dom";
import Screen from '../util/Extensions/Screens'
import RequestHandler from "../util/RequestHandler";

const ResetPassword = (props) => {
  const history = useHistory();
  const [isHavePsrGuid, setIsHavePsrGuid] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    RequestHandler.get(`/Auth/IsHavePsrGuid?PsrGuid=${props.match.params.psrGuid}`).then(response => {
      if (response.success) {
        setIsHavePsrGuid(true);
      }
    });
  }, []);

  const onFinishFailed = () => setLoading(false);

  const onFinish = values => {
    const hide = message.loading('İşleminiz gerçekleştiriliyor..', 0);
    if (values.password !== values.confirm) {
      NotSamePasswordWarning('error')
      setLoading(false)
      hide()
    } else {
      RequestHandler.post(`/Auth/ResetPassword`, {
        psrGuid: props.match.params.psrGuid,
        password: values.password
      }, false, { rawResponse: true }).then(res => {
        if (res.status == 200) {
          openNotificationWithIcon('success');
          hide()
          setTimeout(function () {
            history.push('/home');
          }.bind(this), 2000);
        } else {
          setLoading(false)
        }
      });
    }
  };

  const openNotificationWithIcon = type => {
    notification[type]({
      message: 'BAŞARILI',
      description:
        'Şifre güncelleme işlemi başarı ile gerçekleşti.',
      duration: 2,
    });
  };
  const NotSamePasswordWarning = type => {
    notification[type]({
      message: 'HATA',
      description:
        'Şifreler aynı değil.',
      duration: 2,
    });
  };
  const openNotificationWithIconWarning = type => {
    notification[type]({
      message: 'HATA',
      description:
        'Şifre güncelleme işlemi sırasında bir hata oluştu.',
      duration: 2,
    });
  };
  return (
    isHavePsrGuid === true ?
      <div className="gx-login-container" style={{ backgroundColor: '#f0f8ff' }}>
        <div className="gx-login-content">

          <div className="gx-login-header">
            <img src={require("assets/images/IsimIcinDefaultImage.png")} alt="IsimIcin" title="İşim İçin" style={{ width: '40%' }} />
          </div>
          <div className="gx-mb-4">
            <h3>Şifreyi Yenile</h3>
            <p>Hesabınızın yeni şifresini giriniz.</p>
          </div>

          <Form
            initialValues={{ remember: true }}
            name="basic"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            className="gx-signin-form gx-form-row0">

            <Form.Item rules={[{ required: true, message: 'Lütfen şifrenizi giriniz.' }]} name="password">
              <Input className='gx-input-lineheight' onKeyDown={(evt) => evt.keyCode === 32 && evt.preventDefault()} type="password" placeholder="Yeni Şifrenizi Giriniz" />
            </Form.Item>

            <Form.Item rules={[{ required: true, message: 'Lütfen şifrenizi giriniz.' }]} name="confirm">
              <Input className='gx-input-lineheight' onKeyDown={(evt) => evt.keyCode === 32 && evt.preventDefault()} placeholder="Yeni Şifrenizi Tekrar Giriniz" type="password" />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" onClick={() => setLoading(true)} loading={loading}>
                Yenile
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
      :
      <div>
        <Result
          status="404"
          title="404"
          subTitle="Üzgünüm, böyle bir kullanıcı bulamadım."
          extra={<Button type="primary" href='/signin'> Giriş Sayfasına Dön</Button>}
        />
      </div>
  );
};

export default ResetPassword;
